import { appCookiesContext } from "@/common/other/appCookiesContext";
import errorHandler from "@/common/lib/errorHandler";

/**
 * Static-only helper class for auth related functionality.
 *
 * Ported from constants/authConfigs.js and elsewhere. Likely to be refactored.
 */
class AuthUtils {

  // == Cookie/local storage names ==

  /**
   * Note: Axios automatically uses "XSRF-TOKEN" regardless of what we declare here.
   *
   * @var {string}
   */
  static csrfTokenCookieName = "XSRF-TOKEN";

  /**
   * Associated cookie stores timestamp of last call to API.
   *
   * @var {string}
   */
  static latestRequestLsKey = "p2lr";

  /**
   * Associated cookie stores timestamp of next-to-last call to API.
   *
   * @var {string}
   */
  static prevLatestRequestLsKey = "p2plr";

  /**
   * Associated cookie stores post register destination
   *
   * @var {string}
   */
  static registerDest = "p2regdest";

  /**
   * Associated cookie stores announcement bar dismissed
   *
   * @var {string}
   */
  static announcementBarDismissed = "p2_announcement_bar_dismissed";

  // =====================================

  /**
   * Get current CSRF token cookie value.
   *
   * @return {string}
   */
  static getCsrfToken() {
    let csrfTokenCookie = appCookiesContext.get(AuthUtils.csrfTokenCookieName);
    return csrfTokenCookie;
  }

  /**
   * Remove current CSRF token cookie.
   */
  static removeCsrfToken() {
    try {
      appCookiesContext.remove(AuthUtils.csrfTokenCookieName);
    } catch (err: any) {
      errorHandler(err, false, false);
    }
  }
}

export const getCsrfToken = AuthUtils.getCsrfToken;
export const removeCsrfToken = AuthUtils.removeCsrfToken;
export const csrfTokenCookieName = AuthUtils.csrfTokenCookieName;
export const latestRequestLsKey = AuthUtils.latestRequestLsKey;
export const prevLatestRequestLsKey = AuthUtils.prevLatestRequestLsKey;
export const registerDest = AuthUtils.registerDest;
export const announcementBarDismissed = AuthUtils.announcementBarDismissed;

export default AuthUtils; // @TODO Remove (only allow individual exports)
